<app-inbound-form-wrapper
  data-testid="inbound-warrant-view-form-wrapper"
  [inboundData]="inboundData()"
  [itemDetails]="itemDetails()"
  [viewMode]="true"
  [loading]="loading()"
  [tabType]="tabType()"
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
></app-inbound-form-wrapper>
